import React from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../theme';

const ContactPage: React.FC = () => {
  return (
    <div
      style={{
        backgroundColor: theme.colors.background,
        minHeight: '100vh',
        color: theme.colors.text,
        fontFamily: theme.fonts.body,
        padding: '24px 16px 48px',
      }}
    >
      <div style={{ maxWidth: '720px', margin: '0 auto' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: theme.colors.primary,
            textDecoration: 'none',
            fontSize: theme.fonts.sizeBody,
            marginBottom: '24px',
          }}
        >
          ← Volver al inicio
        </Link>

        <h1
          style={{
            fontFamily: theme.fonts.heading,
            fontSize: '2rem',
            fontWeight: 700,
            marginBottom: '8px',
            color: theme.colors.text,
          }}
        >
          Contacto
        </h1>
        <p
          style={{
            color: theme.colors.textSecondary,
            marginBottom: '32px',
            fontSize: theme.fonts.sizeSmall,
          }}
        >
          Estamos para ayudarte
        </p>

        <section style={{ marginBottom: '28px' }}>
          <h2
            style={{
              fontSize: '1.25rem',
              fontWeight: 700,
              color: theme.colors.primary,
              marginBottom: '12px',
            }}
          >
            Mail
          </h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            Escribinos a{' '}
            <a
              href="mailto:futboleroapp@gmail.com"
              style={{ color: theme.colors.primary }}
            >
              futboleroapp@gmail.com
            </a>{' '}
            y te respondemos a la brevedad.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2
            style={{
              fontSize: '1.25rem',
              fontWeight: 700,
              color: theme.colors.primary,
              marginBottom: '12px',
            }}
          >
            Redes
          </h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            Seguinos y mandanos DM en{' '}
            <a
              href="https://www.instagram.com/futboleroapp"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: theme.colors.primary }}
            >
              Instagram
            </a>{' '}
            o{' '}
            <a
              href="https://www.facebook.com/profile.php?id=61589316503805"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: theme.colors.primary }}
            >
              Facebook
            </a>
            .
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2
            style={{
              fontSize: '1.25rem',
              fontWeight: 700,
              color: theme.colors.primary,
              marginBottom: '12px',
            }}
          >
            Reportar un bug o sugerencia
          </h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            Si encontraste un error o tenés una idea para mejorar Futbolero, contanos por mail
            con el mayor detalle posible. Cada feedback nos ayuda a mejorar.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
